import React, { PropTypes } from 'react';
import s3 from 'shared/constants/s3';
import { Button, Input } from 'bootstrap';
import classnames from 'classnames';
import MessageConstants from 'shared/constants/Messages';
import KeyBindingActions from 'flux/actions/KeyBindingActions';
import { DisplayForAdmin } from 'shared/components/misc/displayForRole.jsx';

export default React.createClass({
  displayName: 'TeleprompterOnboardingOverlay',

  propTypes: {
    display: PropTypes.bool,
    width: PropTypes.number,
    columnSelectionActive: PropTypes.bool,
    rowSelectionActive: PropTypes.bool,
  },

  defaultProps: {
    display: true,
  },

  getInitialState() {
    return {
      columnTitle: '',
    };
  },

  componentDidMount() {
    KeyBindingActions.unbindFullScreenKeys();
  },

  componentWillUnmount() {
    KeyBindingActions.bindFullScreenKeys();
  },

  render() {
    const {
      eventId,
      teamId,
      display,
      columnSelectionActive,
      rowSelectionActive,
    } = this.props;

    if (!display) return null;

    return (
      <div className="tele-onboarding">
        <div
          className={classnames('tele-onboarding-column', {
            active: columnSelectionActive,
          })}
        >
          <div className="tele-onboarding-column-content">
            <h1>
              1. Select Your Prompter Column
              <img
                className="tele-onboarding-arrow"
                src={s3.onboardingTeleprompterArrow}
              />
            </h1>
            <p>{MessageConstants.teleprompterOnboardingColumnSelect}</p>
            <DisplayForAdmin eventId={eventId} teamId={teamId}>
              <div>
                <p>
                  <b>Don&apos;t have a script column? Create one below!</b>
                </p>
                {this._getNewColumnForm()}
              </div>
            </DisplayForAdmin>
          </div>
        </div>
        <div
          className={classnames('tele-onboarding-row', {
            active: rowSelectionActive,
          })}
        >
          <div className="tele-onboarding-row-content">
            <h1>
              <img
                className="tele-onboarding-arrow-opposite"
                src={s3.onboardingTeleprompterArrowOpposite}
              />
              2. Select Your Item
            </h1>
            <p>{MessageConstants.teleprompterOnboardingRowSelect}</p>
          </div>
        </div>
      </div>
    );
  },

  _getNewColumnForm() {
    const { columnTitle } = this.state;
    const btnDisabled = !columnTitle ? true : false;

    return (
      <div className="tele-onboarding-column-form">
        <Input
          type="text"
          placeholder="Column name"
          value={columnTitle}
          onChange={(e) => {
            this.setState({ columnTitle: e.target.value });
          }}
        />
        <Button
          disabled={btnDisabled}
          className={classnames({ active: !btnDisabled })}
          onClick={this._handleCreateColumn}
        >
          Create column
        </Button>
      </div>
    );
  },

  _handleCreateColumn() {
    const { onCreateColumn } = this.props;
    onCreateColumn(this.state.columnTitle);
  },
});
